var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComboOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M8 5.05005C8.015 5.59005 8.24 6.07505 8.6 6.43005L1.05 9.71005C0.95 9.75505 0.85 9.77505 0.75 9.77505C0.355 9.77505 0 9.45005 0 9.02005C0 8.72505 0.175 8.45505 0.45 8.33505L8 5.05005Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M20.0004 9.02005C20.0004 9.56005 19.4454 9.92505 18.9504 9.71005L11.4004 6.43005C11.7604 6.07505 11.9854 5.59005 12.0004 5.05005L19.5504 8.33505C19.8254 8.45505 20.0004 8.72505 20.0004 9.02005Z",
    fill: "#D0D7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M16.5 24H3.5C2.95 24 2.5 23.55 2.5 23V18.5C2.5 16.845 3.845 15.5 5.5 15.5H14.5C16.155 15.5 17.5 16.845 17.5 18.5V23C17.5 23.55 17.05 24 16.5 24Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M10.25 11.125H5.75C5.335 11.125 5 10.79 5 10.375C5 9.96 5.335 9.625 5.75 9.625H10.25C10.665 9.625 11 9.96 11 10.375C11 10.79 10.665 11.125 10.25 11.125Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M14.25 13.875H5.75C5.335 13.875 5 13.54 5 13.125C5 12.71 5.335 12.375 5.75 12.375H14.25C14.665 12.375 15 12.71 15 13.125C15 13.54 14.665 13.875 14.25 13.875Z",
    fill: "#AFB8C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M12.25 1.5H7.75C7.335 1.5 7 1.165 7 0.75C7 0.335 7.335 0 7.75 0H12.25C12.665 0 13 0.335 13 0.75C13 1.165 12.665 1.5 12.25 1.5Z",
    fill: "#AFB8C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M12 5V5.05C11.985 5.59 11.76 6.075 11.4 6.43C11.035 6.78 10.545 7 10 7C9.455 7 8.965 6.78 8.6 6.43C8.24 6.075 8.015 5.59 8 5.05V5C8 3.895 8.895 3 10 3C11.105 3 12 3.895 12 5Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboOutline);
export default __webpack_public_path__ + "static/media/combo-outline.4833ca0d9ee1bdb5e81b6c81b3285e6b.svg";
export { ForwardRef as ReactComponent };